export enum MailingLoginQueryParams {
    TOKEN = 'mailing-token',
    SUID = 'suid',
    ACTION = 'leanplum-auth',
    PROVIDER_ACTION = 'provider-auth',
    GENERATED_AT = 'generatedAt',
    GROUP_BY = 'groupBy'
}
